// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/swiper.min.css'
import './assets/css/style.css'
import common from '@/common/common.js'
import http from "@/common/http.js";
import App from './App'
import store from '@/store/index.js';
import './assets/js/directives.js';
import './assets/js/jquery.SuperSlide.2.1.3.js';
import {
  provinceAndCityData,
	regionData,
	provinceAndCityDataPlus,
	regionDataPlus,
	CodeToText,
	TextToCode
} from 'element-china-area-data'
import router from './router'
import BaiduMap from 'vue-baidu-map'

Vue.prototype.$axios = axios
console.log('process.env.VUE_APP_BASE_URL', process.env.VUE_APP_BASE_URL)
// if (process.env.NODE_ENV === "development") {
// 	axios.defaults.baseURL = '' //本地
// } else {
// 	axios.defaults.baseURL = 'http://192.168.8.104:9002' //线上
// }
Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.use(BaiduMap, {
  ak: 'O4aFVMSLVl1aiTX2sF40aVfC'  // 替换为你的百度地图API密钥
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js